import BasePage from './base-page'

export default class IntroPage extends BasePage {}
